import { useContext } from "react";
import { langContext } from "../../api/Lang";

const el = {
    navLabel: "Νέα",
    navUnreadBadge: (count: number) => (count === 1 ? "1 αδιάβαστη ενημέρωση" : `${count} αδιάβαστες ενημερώσεις`),
    emptyTitle: "Δεν υπάρχουν ενημερώσεις ακόμα",
    emptyBody: "Όταν υπάρχει κάτι νέο για εσένα, θα το δεις εδώ.",
    attachmentAria: "Λήψη συνημμένου",
    messageCount: (count: number) => (count === 1 ? "1 ενημέρωση" : `${count} ενημερώσεις`),
    pageSummary: (from: number, to: number, total: number) => `${from}–${to} από ${total}`,
};

const en: typeof el = {
    navLabel: "News",
    navUnreadBadge: (count: number) => (count === 1 ? "1 unread announcement" : `${count} unread announcements`),
    emptyTitle: "No updates yet",
    emptyBody: "When there is something new for you, you will see it here.",
    attachmentAria: "Download attachment",
    messageCount: (count: number) => (count === 1 ? "1 announcement" : `${count} announcements`),
    pageSummary: (from: number, to: number, total: number) => `${from}–${to} of ${total}`,
};

const newsLangs = { el, en };

export function useNewsStrings() {
    const [lang] = useContext(langContext);
    return newsLangs[lang];
}
